import { formatDate, formatPhoneNumber, formatSSN } from './CommonUtil';

const formFieldFormatter = (name, value) => {
  switch (name) {
    case 'dateOfBirth':
      return formatDate(value);
    case 'phone':
      return formatPhoneNumber(value);
    case 'ssn':
      return formatSSN(value);
    default:
      return value;
  }
};

export default formFieldFormatter;
